import { render, staticRenderFns } from "./VisualGradeReview.vue?vue&type=template&id=dc14cdb8&scoped=true"
import script from "./VisualGradeReview.vue?vue&type=script&lang=js"
export * from "./VisualGradeReview.vue?vue&type=script&lang=js"
import style0 from "./VisualGradeReview.vue?vue&type=style&index=0&id=dc14cdb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc14cdb8",
  null
  
)

export default component.exports